import { render, staticRenderFns } from "./GetMqGame.vue?vue&type=template&id=46387084&scoped=true"
import script from "./GetMqGame.vue?vue&type=script&lang=js"
export * from "./GetMqGame.vue?vue&type=script&lang=js"
import style0 from "./GetMqGame.vue?vue&type=style&index=0&id=46387084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46387084",
  null
  
)

export default component.exports